<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết chấm công</h1>
      <div style="float: right">
        <button @click="$router.go(-1)" class="btn btn-outline-secondary ml-2">Quay lại</button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div v-if="loading" class="card-body p-10 b-t-1-869fb229 text-center">
        <!-- <i class='bx bx-loader-circle bx-spin bx-rotate-90 h1'></i> -->
        <h3>KHÔNG CÓ DỮ LIỆU CHẤM CÔNG</h3>
      </div>
      <div v-else class="card-body p-10 b-t-1-869fb229">
        <span class="de-img"><img :src="staffAvatar" alt="img" /></span>
        <div class="de-info" v-if="this.checkOut.length > 0">
          <h3 class="de-name">{{ checkOut[0].name }}</h3>
          <span class="s">Mã: {{ checkOut[0].companyCode }}</span>
        </div>
        <div class="de-info" v-if="this.checkIn.length > 0 && this.checkOut.length == 0">
          <h3 class="de-name">{{ checkIn[0].name }}</h3>
          <span class="s">Mã: {{ checkIn[0].companyCode }}</span>
        </div>
        <div class="clearfix"></div>
        <div class="form-row">
          <div class="col-md-6 my-2">
            <h1 class="f16 pb-1"><b>Checkin</b></h1>
            <div class="my-2" v-for="(item, index) in checkIn" :key="index">
              <div class="box-detail mb-4">
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Thời gian</label>
                  <div class="col-sm-9">
                    <p class="form-control-plaintext f14">{{ item.timeCheckin }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Ghi chú</label>
                  <div class="col-sm-9">
                    <p type="text" class="form-control-plaintext f14">{{ item.note }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Địa điểm</label>
                  <div class="col-sm-9">
                    <a href="#" @click="showMapModal(item.latitude, item.longtitude)" class="f14"
                      >{{ item.latitude | placeHolder }} / {{ item.longtitude | placeHolder }}</a
                    >
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Ảnh</label>
                  <div class="col-sm-9">
                    <ul v-if="item.imageUrls" class="list-img">
                      <li v-for="(image, imageIndex) in item.imageUrls" :key="imageIndex">
                        <a data-toggle="modal">
                          <img v-viewer class="image-detail" :src="image" alt="" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row mb-0" v-if="item.status">
                  <label class="col-sm-3 col-form-label f14">Trạng thái</label>
                  <div class="col-sm-9 d-flex align-items-center">
                    <span class="badge" v-bind:class="[item.status ? item.status : '']">{{
                      item.status | mapTextStatus(listStatusCheckIn)
                    }}</span>
                  </div>
                </div>
                <div class="form-group row mb-0" v-if="item.approvedDate">
                  <label class="col-sm-3 col-form-label f14"
                    >Thời gian {{ item.status === 'APRROVED' ? 'duyệt' : 'từ chối' }}</label
                  >
                  <div class="col-sm-9 d-flex align-items-center">
                    <p class="form-control-plaintext f14">{{ item.approvedDate }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0" v-if="item.approvedName">
                  <label class="col-sm-3 col-form-label f14">
                    {{ item.status === 'APRROVED' ? 'Người duyệt' : 'Người từ chối' }}
                  </label>
                  <div class="col-sm-9 d-flex align-items-center">
                    <p class="form-control-plaintext f14">{{ item.approvedName }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0" v-if="item.rejectReason">
                  <label class="col-sm-3 col-form-label f14">Lý do từ chối</label>
                  <div class="col-sm-9 d-flex align-items-center">
                    <p class="form-control-plaintext f14">{{ item.rejectReason }}</p>
                  </div>
                </div>

                <div
                  class="form-group row mt-3"
                  v-if="
                    item.status &&
                    item.status === 'WAITING' &&
                    dataPermission &&
                    dataPermission.includes('CNPS_ATTN_APPROVE')
                  "
                >
                  <label class="col-sm-3 col-form-label f14"></label>
                  <div class="col-sm-9">
                    <b-button variant="success" @click="confirmApproveAttendance(item)" class="mr-2"
                      >Duyệt</b-button
                    >
                    <b-button variant="danger" @click="showRejectAttendance(item)"
                      >Từ chối</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 my-2">
            <h1 class="f16 pb-1"><b>Checkout</b></h1>
            <div class="my-2" v-for="(item, index) in checkOut" :key="index">
              <div class="box-detail mb-4">
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Thời gian</label>
                  <div class="col-sm-9">
                    <p class="form-control-plaintext f14">{{ item.timeCheckout }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Ghi chú</label>
                  <div class="col-sm-9">
                    <p type="text" class="form-control-plaintext f14">{{ item.note }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Địa điểm</label>
                  <div class="col-sm-9">
                    <a href="#" @click="showMapModal(item.latitude, item.longtitude)" class="f14"
                      >{{ item.latitude | placeHolder }} / {{ item.longtitude | placeHolder }}</a
                    >
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <label class="col-sm-3 col-form-label f14">Ảnh</label>
                  <div class="col-sm-9">
                    <ul v-if="item.imageUrls" class="list-img">
                      <li v-for="(image, imageIndex) in item.imageUrls" :key="imageIndex">
                        <a data-toggle="modal">
                          <img v-viewer class="image-detail" :src="image" alt="" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="form-group row mb-0" v-if="item.status">
                  <label class="col-sm-3 col-form-label f14">Trạng thái</label>
                  <div class="col-sm-9 d-flex align-items-center">
                    <span class="badge" v-bind:class="[item.status ? item.status : '']">{{
                      item.status | mapTextStatus(listStatusCheckIn)
                    }}</span>
                  </div>
                </div>
                <div class="form-group row mb-0" v-if="item.approvedDate">
                  <label class="col-sm-3 col-form-label f14"
                    >Thời gian {{ item.status === 'APRROVED' ? 'duyệt' : 'từ chối' }}
                  </label>
                  <div class="col-sm-9 d-flex align-items-center">
                    <p class="form-control-plaintext f14">{{ item.approvedDate }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0" v-if="item.approvedName">
                  <label class="col-sm-3 col-form-label f14">{{
                    item.status === 'APRROVED' ? 'Người duyệt' : 'Người từ chối'
                  }}</label>
                  <div class="col-sm-9 d-flex align-items-center">
                    <p class="form-control-plaintext f14">{{ item.approvedName }}</p>
                  </div>
                </div>
                <div class="form-group row mb-0" v-if="item.rejectReason">
                  <label class="col-sm-3 col-form-label f14">Lý do từ chối</label>
                  <div class="col-sm-9 d-flex align-items-center">
                    <p class="form-control-plaintext f14">{{ item.rejectReason }}</p>
                  </div>
                </div>

                <div
                  class="form-group row mt-3"
                  v-if="
                    item.status &&
                    item.status === 'WAITING' &&
                    dataPermission &&
                    dataPermission.includes('CNPS_ATTN_APPROVE')
                  "
                >
                  <label class="col-sm-3 col-form-label f14"></label>
                  <div class="col-sm-9">
                    <b-button variant="success" @click="confirmApproveAttendance(item)" class="mr-2"
                      >Duyệt</b-button
                    >
                    <b-button variant="danger" @click="showRejectAttendance(item)"
                      >Từ chối</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg">
      <div>
        <GmapMap
          :center="{ lat: latitude, lng: longtitude }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker :position="{ lat: latitude, lng: longtitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>

    <b-modal id="modal-scoped" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button type="button" class="close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <loading :active.sync="showLoading" :is-full-page="true"> </loading>

    <div v-if="showModalReject">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Lý do từ chối</h5>
                  <button
                    type="button"
                    class="close"
                    @click="showModalReject = false"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <form>
                    <div class="form-group pos-relative">
                      <textarea v-model.trim="rejectReason" class="form-control f12"></textarea>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                    :disabled="!rejectReason || !rejectReason.trim() || rejectReason.length < 2"
                    @click="rejectAttendance()"
                    class="btn btn-success"
                  >
                    Xác nhận
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { AttentdentService } from '@/services/attentdent.service'
  import userDefaultImage from '@/assets/img/user.svg'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import { mapGetters } from 'vuex'

  export default {
    created() {
      this.fetchData()
    },
    data() {
      return {
        time: this.$route.params.time,
        userId: this.$route.params.userId,
        dataAttendance: [],
        checkIn: [],
        checkOut: [],
        loading: true,
        staffName: null,
        staffCode: null,
        staffAvatar: null,
        listData: [],
        longtitude: 10,
        latitude: 10,
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        listStatusCheckIn: [
          { id: 'WAITING', text: 'Chờ duyệt' },
          { id: 'APRROVED', text: 'Đã duyệt' },
          { id: 'DENIED', text: 'Từ chối' },
        ],
        showLoading: false,
        showModalReject: false,
        rejectReason: '',
        rejectItem: null,
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    components: {
      Loading,
    },

    methods: {
      async fetchData(userId, time) {
        try {
          this.loading = true
          const data = await AttentdentService.getDetail({
            userId: this.userId,
            time: this.time,
          })
          if (data.success) {
            this.dataAttendance = data.data
            this.checkIn = this.dataAttendance.filter(e => e.timeCheckin)
            this.checkOut = this.dataAttendance.filter(e => e.timeCheckout)
            this.staffAvatar =
              data.data[0] && data.data[0].avatar ? data.data[0].avatar : userDefaultImage
          }
        } catch (e) {
          console.log(e)
          this.error = e.message
        } finally {
          this.loading = false
        }
      },

      showMapModal(lat, long) {
        this.latitude = parseFloat(lat)
        this.longtitude = parseFloat(long)
        this.$refs['modal-map'].show()
      },
      confirmApproveAttendance(item) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: `Bạn chắc chắn duyệt <b>${item?.timeCheckout ? 'Checkout' : 'Checkin'}</b> của nhân viên <b>${this.checkOut?.[0]?.name ?? this.checkIn?.[0]?.name}</b>`,
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Duyệt chấm công',
            okTitle: 'Duyệt',
            cancelTitle: 'Bỏ qua',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.approveAttendance(item)
            }
          })
      },
      async approveAttendance(item) {
        try {
          this.showLoading = true
          const response = await AttentdentService.approveAttendance({
            attnId: item.attnId ? item.attnId : '',
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = response.message
            await this.fetchData()
          } else {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      showRejectAttendance(item) {
        this.showModalReject = true
        this.rejectItem = item
      },

      async rejectAttendance() {
        try {
          this.showModalReject = false
          this.showLoading = true
          const response = await AttentdentService.rejectAttendance({
            attnId: this.rejectItem.attnId ? this.rejectItem.attnId : '',
            rejectReason: this.rejectReason,
          })
          if (response.code === 1000) {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = response.message
            await this.fetchData()
          } else {
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped>
  .list-img li {
    height: 100%;
    width: 100%;
  }
  .list-img a {
    width: 160px;
    height: 160px;
  }
  .image-detail {
    width: 160px;
    height: 160px;
  }
</style>
